import { DiskusiRepositoryInterface, DiskusiResponse } from '../../../data/contracts/Diskusi';
import { DiskusiDataMapper } from '../../../data/mappers/Diskusi';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';

export class DiskusiApiRepository implements DiskusiRepositoryInterface {
  private apiService: ApiService;
  private mapper: DiskusiDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: DiskusiDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  /**
   * Get diskusi by pengetahuan ID with pagination
   */
  public async getDiskusi(pengetahuanId: number, page: number = 1): Promise<DiskusiResponse> {
    const headers = new Map<string, string>();

    try {
      const dataResponse = await this.apiService.invoke(
        'get',
        this.endpoints.diskusi() + '/' + pengetahuanId,
        {
          page: page,
          sort_by: 'desc'
        },
        null,
        headers
      );
      return this.mapper.convertListDiskusiDataFromApi(dataResponse);
    } catch (error) {
      console.error('Error in getDiskusi:', error);
      throw error;
    }
  }

  /**
   * Store new diskusi
   */
  public async storeDiskusi(
    pengetahuanId: number,
    message: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.diskusi() + '/' + pengetahuanId,
      {
        message,
      },
      null,
      headers
    );
    return dataResponse;
  }
}
